import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LowercaseButton from "../../../components/LowercaseButton/LowercaseButton";
import React, { useState } from "react";
import {
  DELETE,
  EDIT,
  SUB_ROLE_DELETE,
  SUB_ROLE_DELETE_CONFIRMATION,
  SUB_ROLE_EDIT,
} from "../../../utility/TextLabels";
import { SubRole } from "../Models/SubRole";
import SubRoleDialog from "../SubRoleDialog/SubRoleDialog";
import ConfirmationDialog from "../../../components/ConfirmationDialog/ConfirmationDialog";

interface SubRoleItemProps {
  name: string;
  id?: string;
  onUpdateSubRole: (subRole: SubRole) => void;
  onDeleteSubRole: (id: string) => void;
}

const SubRoleItem: React.FC<SubRoleItemProps> = ({
  name,
  id,
  onUpdateSubRole,
  onDeleteSubRole,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 1,
        paddingLeft: 2,
        paddingRight: 3,
        paddingTop: 1,
      }}
    >
      <Box>
        <Typography
          variant="h6"
          fontFamily="Lato"
          fontSize="16px"
          fontStyle="normal"
          fontWeight={400}
          lineHeight="normal"
        >
          {name}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: "1em",
          alignItems: "flex-end",
        }}
      >
        <LowercaseButton color="primary" onClick={() => setIsOpen(true)}>
          {EDIT}
        </LowercaseButton>
        <SubRoleDialog
          existingId={id}
          title={SUB_ROLE_EDIT}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmit={onUpdateSubRole}
        />
        <LowercaseButton
          color="secondary"
          onClick={() => setIsConfirmationOpen(true)}
        >
          {DELETE}
        </LowercaseButton>
        <ConfirmationDialog
          title={SUB_ROLE_DELETE}
          text={SUB_ROLE_DELETE_CONFIRMATION}
          isOpen={isConfirmationOpen}
          onClose={() => setIsConfirmationOpen(false)}
          onSubmit={() => onDeleteSubRole(id!)}
        />
      </Box>
    </Box>
  );
};

export default SubRoleItem;
